import { useMemo } from "react";
import { apiClient, useUser } from "../api-client";

export interface AccountUser {
  id: string;
  firstName: string;
  lastName: string;
  isSelf: boolean;
}

export function useAccountUsers(): AccountUser[] {
  const { data: currentUser } = useUser();
  const { data: usersResponse } = apiClient.useQuery(
    "get",
    "/api/user",
    {},
    { enabled: !!currentUser },
  );

  return useMemo(() => {
    if (!currentUser) return [];
    const users: AccountUser[] = [];

    // Add current user
    users.push({
      id: currentUser.id,
      firstName: currentUser.firstName,
      lastName: currentUser.lastName,
      isSelf: true,
    });

    // Add other users from primary group
    if (usersResponse) {
      const primaryGroupId = currentUser.groups?.find(
        (g) => g.group.type === "Primary",
      )?.group.id;

      if (primaryGroupId) {
        usersResponse.forEach((u) => {
          if (
            u.id !== currentUser.id &&
            u.groups.some((g) => g.group.id === primaryGroupId)
          ) {
            users.push({
              id: u.id,
              firstName: u.firstName,
              lastName: u.lastName,
              isSelf: false,
            });
          }
        });
      }
    }

    return users;
  }, [currentUser, usersResponse]);
}

